import React, {
    useEffect,
    useState,
    useRef,
} from "react";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import AdminLayout from "./AdminLayout";

const AdminOnlineRegistration = () => {

    const [data, setData] =
        useState([]);

    const [selectedStudent,
        setSelectedStudent] =
        useState(null);

    const printRef = useRef();

    // FETCH
    const fetchData = () => {

        fetch(
            "https://stjosephweb.ilakshyaerp.in/api/online-registration/all"
        )
            .then((res) => res.json())
            .then((res) =>
                setData(
                    res.registrations || []
                )
            );
    };

    useEffect(() => {
        fetchData();
    }, []);

    // DELETE
    const handleDelete =
        async (id) => {

            const confirmDelete =
                window.confirm(
                    "Are you sure?"
                );

            if (!confirmDelete)
                return;

            try {

                const res =
                    await fetch(
                        `https://stjosephweb.ilakshyaerp.in/api/online-registration/delete/${id}`,
                        {
                            method: "PUT",
                        }
                    );

                const data =
                    await res.json();

                alert(
                    data.message
                );

                fetchData();

            } catch {

                alert(
                    "Delete failed ❌"
                );

            }
        };

    const handleDownload = async () => {

        try {

            if (!data || data.length === 0) {

                alert(
                    "No registration data found."
                );

                return;
            }

            // PDF
            const pdf =
                new jsPDF(
                    "l",
                    "mm",
                    "a4"
                );

            // PAGE WIDTH
            const pageWidth =
                pdf.internal.pageSize.getWidth();

            // HEADER
            pdf.setFillColor(
                7,
                47,
                95
            );

            pdf.rect(
                0,
                0,
                pageWidth,
                25,
                "F"
            );

            // TITLE
            pdf.setTextColor(
                255,
                255,
                255
            );

            pdf.setFontSize(20);

            pdf.setFont(
                "helvetica",
                "bold"
            );

            pdf.text(
                "ONLINE REGISTRATION REPORT",
                14,
                16
            );

            // DATE
            pdf.setFontSize(10);

            pdf.text(
                `Generated: ${new Date().toLocaleString()}`,
                pageWidth - 70,
                16
            );

            // TOTAL
            pdf.setTextColor(
                0,
                0,
                0
            );

            pdf.setFontSize(12);

            pdf.text(
                `Total Registrations: ${data.length}`,
                14,
                35
            );

            // TABLE
            autoTable(
                pdf,
                {
                    startY: 42,

                    head: [[

                        "S.No",
                        "Student",
                        "Gender",
                        "Father",
                        "Mother",
                        "Mobile",
                        "DOB",
                        "Class",
                        "Stream",
                        "Last School",
                        "Board",
                        "Overall %",
                        "Maths %",
                        "Science %"

                    ]],

                    body: data.map(
                        (
                            d,
                            index
                        ) => [

                                index + 1,

                                d.studentName || "N/A",

                                d.gender || "N/A",

                                d.fatherName || "N/A",

                                d.motherName || "N/A",

                                d.mobile || "N/A",

                                d.dob || "N/A",

                                d.admissionClass || "N/A",

                                d.stream || "N/A",

                                d.lastSchool || "N/A",

                                d.boardType || "N/A",

                                d.overallPercentage || "N/A",

                                d.mathsPercentage || "N/A",

                                d.sciencePercentage || "N/A"

                            ]
                    ),

                    theme: "grid",

                    styles: {

                        fontSize: 8,

                        cellPadding: 3,

                        overflow: "linebreak",

                        halign: "center",

                        valign: "middle",

                    },

                    headStyles: {

                        fillColor: [
                            11,
                            93,
                            183
                        ],

                        textColor: [
                            255,
                            255,
                            255
                        ],

                        fontStyle: "bold",

                        fontSize: 9,

                    },

                    alternateRowStyles: {

                        fillColor: [
                            245,
                            247,
                            250
                        ],

                    },

                    bodyStyles: {

                        textColor: [
                            55,
                            65,
                            81
                        ],

                    },

                    margin: {

                        left: 8,
                        right: 8,

                    },

                    didDrawPage: () => {

                        // FOOTER
                        const pageCount =
                            pdf.internal.getNumberOfPages();

                        const currentPage =
                            pdf.internal.getCurrentPageInfo().pageNumber;

                        pdf.setFontSize(9);

                        pdf.setTextColor(
                            120
                        );

                        pdf.text(
                            `Page ${currentPage} of ${pageCount}`,
                            pageWidth - 40,
                            pdf.internal.pageSize.height - 10
                        );
                    },

                }
            );

            // SAVE
            pdf.save(
                `Online_Registrations_${Date.now()}.pdf`
            );

        } catch (error) {

            console.error(error);

            alert(
                "PDF download failed ❌"
            );
        }
    };

    return (
        <AdminLayout>

            <div className="notice-page">

                {/* HEADER */}
                <div className="notice-card">

                    <div
                        className="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
                    >

                        <div>

                            <h2>
                                Online Registration
                            </h2>

                            <p>
                                Total Registrations :
                                {" "}
                                <strong>
                                    {data.length}
                                </strong>
                            </p>

                        </div>

                        {/* DOWNLOAD BUTTON */}
                        <button
                            onClick={handleDownload}
                            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition-all duration-300"
                        >
                            Download
                        </button>

                    </div>

                </div>

                {/* TABLE */}
                <div className="notice-table">

                    <h2>
                        All Registration Data
                    </h2>

                    <div
                        style={{
                            overflowX:
                                "auto",
                        }}
                    >

                        <table>

                            <thead>
                                <tr>

                                    <th>
                                        Photo
                                    </th>

                                    <th>
                                        Student
                                    </th>

                                    <th>
                                        Father
                                    </th>

                                    <th>
                                        Mobile
                                    </th>

                                    <th>
                                        Class
                                    </th>

                                    <th>
                                        Action
                                    </th>

                                </tr>
                            </thead>

                            <tbody>

                                {data.length >
                                    0 ? (

                                    data.map(
                                        (d) => (
                                            <tr
                                                key={
                                                    d.id
                                                }
                                            >

                                                {/* PHOTO */}
                                                <td>

                                                    <img
                                                        src={`https://stjosephweb.ilakshyaerp.in/uploads/registration/${d.photo}`}
                                                        alt="student"
                                                        width="80"
                                                        height="80"
                                                        style={{
                                                            objectFit:
                                                                "cover",
                                                            borderRadius:
                                                                "8px",
                                                        }}
                                                    />

                                                </td>

                                                {/* STUDENT */}
                                                <td>
                                                    <strong>
                                                        {
                                                            d.studentName
                                                        }
                                                    </strong>

                                                    <br />

                                                    {
                                                        d.gender
                                                    }
                                                </td>

                                                {/* FATHER */}
                                                <td>
                                                    {
                                                        d.fatherName
                                                    }
                                                </td>

                                                {/* MOBILE */}
                                                <td>
                                                    {
                                                        d.mobile
                                                    }
                                                </td>

                                                {/* CLASS */}
                                                <td>
                                                    {
                                                        d.admissionClass
                                                    }
                                                </td>

                                                {/* ACTION */}
                                                <td>

                                                    <div
                                                        style={{
                                                            display:
                                                                "flex",
                                                            gap: "10px",
                                                        }}
                                                    >

                                                        {/* VIEW */}
                                                        <button
                                                            style={{
                                                                background:
                                                                    "#0B5DB7",
                                                                color:
                                                                    "#fff",
                                                                border:
                                                                    "none",
                                                                padding:
                                                                    "8px 14px",
                                                                cursor:
                                                                    "pointer",
                                                                borderRadius:
                                                                    "5px",
                                                            }}
                                                            onClick={() =>
                                                                setSelectedStudent(
                                                                    d
                                                                )
                                                            }
                                                        >
                                                            View
                                                        </button>

                                                        {/* DELETE */}
                                                        <button
                                                            className="delete-btn"
                                                            onClick={() =>
                                                                handleDelete(
                                                                    d.id
                                                                )
                                                            }
                                                        >
                                                            Delete
                                                        </button>

                                                    </div>

                                                </td>
                                            </tr>
                                        )
                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            style={{
                                                textAlign:
                                                    "center",
                                            }}
                                        >
                                            No Registration
                                            Found
                                        </td>

                                    </tr>
                                )}

                            </tbody>
                        </table>

                    </div>
                </div>

                {/* VIEW MODAL */}
                {selectedStudent && (

                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex justify-center items-center p-4">

                        <div
                            ref={printRef}
                            className="bg-white w-full max-w-6xl rounded-3xl overflow-hidden shadow-2xl animate-fadeIn max-h-[95vh] overflow-y-auto"
                        >

                            {/* TOP HEADER */}
                            <div className="bg-gradient-to-r from-[#072F5F] to-[#0B5DB7] px-8 py-5 flex items-center justify-between">

                                <div>

                                    <h2 className="text-3xl font-bold text-white">
                                        Student Registration Details
                                    </h2>

                                    <p className="text-blue-100 mt-1">
                                        Complete student admission information
                                    </p>

                                </div>

                                <button
                                    onClick={() =>
                                        setSelectedStudent(null)
                                    }
                                    className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-lg font-semibold transition-all duration-300"
                                >
                                    Close
                                </button>

                            </div>

                            {/* CONTENT */}
                            <div className="grid grid-cols-1 lg:grid-cols-3">

                                {/* LEFT IMAGE */}
                                <div className="bg-[#F5F7FB] p-8 flex flex-col items-center border-r">

                                    <img
                                        src={`https://stjosephweb.ilakshyaerp.in/uploads/registration/${selectedStudent.photo}`}
                                        alt="student"
                                        className="w-64 h-72 object-cover rounded-2xl shadow-xl border-4 border-white"
                                    />
                                    <div className="mt-6 w-full bg-white rounded-2xl shadow-md p-5">

                                        <div className="flex justify-between border-b pb-3 mb-3">
                                            <span className="font-semibold text-gray-600">
                                                Name
                                            </span>

                                            <span className="font-bold text-[#072F5F]">
                                                {selectedStudent.studentName}
                                            </span>
                                        </div>
                                        <div className="flex justify-between border-b pb-3 mb-3">
                                            <span className="font-semibold text-gray-600">
                                                Class
                                            </span>

                                            <span className="font-bold text-[#072F5F]">
                                                {selectedStudent.admissionClass}
                                            </span>
                                        </div>
                                        <div className="flex justify-between border-b pb-3 mb-3">
                                            <span className="font-semibold text-gray-600">
                                                Gender
                                            </span>

                                            <span className="font-bold text-[#072F5F]">
                                                {selectedStudent.gender}
                                            </span>
                                        </div>

                                        <div className="flex justify-between border-b pb-3 mb-3">
                                            <span className="font-semibold text-gray-600">
                                                DOB
                                            </span>

                                            <span className="font-bold text-[#072F5F]">
                                                {selectedStudent.dob}
                                            </span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span className="font-semibold text-gray-600">
                                                Mobile
                                            </span>

                                            <span className="font-bold text-[#072F5F]">
                                                {selectedStudent.mobile}
                                            </span>
                                        </div>

                                    </div>

                                    {/* QUERY */}
                                    <div className="mt-10">

                                        <div className="flex items-center justify-between mb-5">

                                            <h3 className="text-2xl font-bold text-[#072F5F]">
                                                Student Query
                                            </h3>

                                            <div className="w-16 h-1 bg-[#D4A017] rounded-full"></div>

                                        </div>

                                        <div className="relative bg-gradient-to-br from-[#F8FAFC] to-[#EEF4FF] border border-[#DCE7F7] rounded-3xl p-7 shadow-md overflow-hidden">

                                            {/* DECORATION */}
                                            <div className="absolute top-0 right-0 w-32 h-32 bg-[#0B5DB7]/5 rounded-full blur-3xl"></div>

                                            {/* ICON */}
                                            <div className="w-14 h-14 rounded-2xl bg-[#072F5F] text-white flex items-center justify-center text-2xl mb-5 shadow-lg">

                                                ?

                                            </div>

                                            {/* QUERY TEXT */}
                                            <p className="text-gray-700 leading-9 text-lg relative z-10">

                                                {selectedStudent.queryText
                                                    ? selectedStudent.queryText
                                                    : "No query submitted by the student."}

                                            </p>

                                        </div>

                                    </div>

                                </div>

                                {/* RIGHT DETAILS */}

                                <div className="lg:col-span-2 p-8">

                                    <h3 className="text-2xl font-bold text-[#072F5F] mb-8 border-b pb-4">
                                        Academic & Family Details
                                    </h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        {/* ITEM */}
                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Father Name
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.fatherName}
                                            </h4>

                                        </div>

                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Mother Name
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.motherName}
                                            </h4>

                                        </div>

                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Last School
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.lastSchool}
                                            </h4>

                                        </div>

                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Board Type
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.boardType}
                                            </h4>

                                        </div>

                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Last Class
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.lastClass}
                                            </h4>

                                        </div>

                                        <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-1">
                                                Stream
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F]">
                                                {selectedStudent.stream}
                                            </h4>

                                        </div>

                                    </div>

                                    {/* PERCENTAGE */}
                                    <div className="mt-10">

                                        <h3 className="text-2xl font-bold text-[#072F5F] mb-6">
                                            Academic Performance
                                        </h3>

                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                                            <div className="bg-gradient-to-br from-[#072F5F] to-[#0B5DB7] text-white rounded-2xl p-6 shadow-lg">

                                                <p className="text-sm uppercase tracking-wide opacity-80">
                                                    Overall %
                                                </p>

                                                <h2 className="text-4xl font-bold mt-2">
                                                    {selectedStudent.overallPercentage}
                                                </h2>

                                            </div>

                                            <div className="bg-gradient-to-br from-[#0B5DB7] to-[#3B82F6] text-white rounded-2xl p-6 shadow-lg">

                                                <p className="text-sm uppercase tracking-wide opacity-80">
                                                    Maths %
                                                </p>

                                                <h2 className="text-4xl font-bold mt-2">
                                                    {selectedStudent.mathsPercentage}
                                                </h2>

                                            </div>

                                            <div className="bg-gradient-to-br from-[#1E40AF] to-[#2563EB] text-white rounded-2xl p-6 shadow-lg">

                                                <p className="text-sm uppercase tracking-wide opacity-80">
                                                    Science %
                                                </p>

                                                <h2 className="text-4xl font-bold mt-2">
                                                    {selectedStudent.sciencePercentage}
                                                </h2>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                )}

            </div>
        </AdminLayout>
    );
};

export default AdminOnlineRegistration;